// Registers the DropSquadz PWA service worker in production builds only.
// Safe no-op in development to avoid stale caches while iterating.

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV !== 'production') return;

  // When a new service worker takes control (new deploy), reload once to load fresh code
  let refreshed = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshed) return;
    refreshed = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => {
        reg.update().catch(() => {});
        // Check for updates every time the tab is focused
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            reg.update().catch(() => {});
          }
        });
      })
      .catch(() => {
        // silent fail — PWA is an enhancement, not a requirement
      });
  });
}
